import Vue from 'vue';
import core, { CoreOptions } from '@glittr/frontend-core';
import toccoWidgets from '@glittr/frontend-core/src-modules/tocco/widgets';
import router from './router';
import services from './services/v1';
import ilLanguageSelection from './components/il-language-selection.vue';

Vue.config.productionTip = false;
const coreOptions = {
  // appId: 'custom-mount-id'
  router,
  Vue,
} as CoreOptions;
// Core entry point
Vue.use(core, coreOptions);
Vue.nextTick(() => {
  toccoWidgets.loadModule(coreOptions, Vue);
});

// APP____________________________________________________________

// STYLES
require('./assets/styles/main.scss');

// PLUGINS
Vue.use(services);

// COMPONENTS
Vue.component('IlLanguageSelection', ilLanguageSelection);

// GUARDS
// Vue.$guards.push(yourGuard);

// LAYOUTS
const reqLayouts = require.context('./views/layouts', true);
reqLayouts.keys().forEach((componentPath) => {
  let componentName = componentPath.substr(componentPath.lastIndexOf('/') + 1, componentPath.length - 1);
  componentName = componentName.replace('.vue', '');
  const component = reqLayouts(componentPath).default;
  Vue.component(componentName, component);
});

// _______________________________________________________________

require('./store');

declare module '@core/plugins/config/config' {
  interface ConfigType {
    // add custom config props here
  }
}
